// extracted by mini-css-extract-plugin
export default {"jobPlacementsWrapper":"UserAddedJobPlacement_jobPlacementsWrapper__6ZW5X"};